(function () {
  var root = document.querySelector('[data-hbc-cancel-booking]');
  if (!root) return;
  var params = new URLSearchParams(window.location.search);
  var bookingId = params.get('booking') || '';
  var token = params.get('token') || '';
  var status = params.get('status') || '';
  var apiUrl = root.getAttribute('data-api-url');
  var cancelUrl = root.getAttribute('data-cancel-url');
  var loading = root.querySelector('[data-cancel-loading]');
  var result = root.querySelector('[data-cancel-result]');
  var reasonForm = root.querySelector('[data-cancel-reason]');
  var title = root.querySelector('[data-cancel-title]');

  function request(action, reason) {
    return fetch(apiUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, bookingId: bookingId, token: token, reason: reason || '' })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data.ok) throw new Error(data.message || 'Please try again.');
        return data;
      });
    });
  }
  function show(message, successful) {
    loading.hidden = true;
    result.hidden = false;
    result.classList.toggle('is-success', successful);
    result.textContent = message;
    title.textContent = successful ? 'CANCELLED' : 'Unable to cancel';
  }
  if (!/^HBC-[A-Z0-9-]{6,80}$/i.test(bookingId) || !/^[a-z0-9_-]{8,128}$/i.test(token)) {
    show('This cancellation link is invalid. Open the original link from your confirmation email.', false);
    return;
  }
  if (status === 'cancelled') {
    show('YOUR PLACE HAS BEEN CANCELLED AND REMOVED FROM THE CLASS LIST.', true);
    reasonForm.hidden = false;
  } else if (status === 'invalid') {
    show('This cancellation link is invalid. Open the original link from your confirmation email.', false);
  } else if (status === 'error') {
    request('lookup').then(function (data) {
      if (data.booking && data.booking.cancelled) {
        show('YOUR PLACE HAS BEEN CANCELLED AND REMOVED FROM THE CLASS LIST.', true);
        reasonForm.hidden = false;
        return;
      }
      show('Your booking could not be cancelled. Please try the original link again or contact the club.', false);
    }).catch(function () {
      show('Your booking could not be cancelled. Please try the original link again or contact the club.', false);
    });
  } else {
    request('confirm').then(function () {
      show('YOUR PLACE HAS BEEN CANCELLED AND REMOVED FROM THE CLASS LIST.', true);
      reasonForm.hidden = false;
    }).catch(function (error) {
      request('lookup').then(function (data) {
        if (data.booking && data.booking.cancelled) {
          show('YOUR PLACE HAS BEEN CANCELLED AND REMOVED FROM THE CLASS LIST.', true);
          reasonForm.hidden = false;
          return;
        }
        show(error.message || 'Your booking could not be cancelled. Please contact the club.', false);
      }).catch(function () {
        show(error.message || 'Your booking could not be cancelled. Please contact the club.', false);
      });
    });
  }

  reasonForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var select = root.querySelector('[data-reason-select]').value;
    var note = root.querySelector('[data-reason-note]').value.trim();
    var reason = [select, note].filter(Boolean).join(': ');
    var button = root.querySelector('[data-reason-submit]');
    if (!reason) { reasonForm.hidden = true; return; }
    button.disabled = true;
    button.textContent = 'Sending...';
    request('reason', reason).then(function () {
      button.textContent = 'Thank you';
      setTimeout(function () { reasonForm.hidden = true; }, 800);
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Try again';
    });
  });
}());
